
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { CompoundButton } from 'office-ui-fabric-react/lib/Button';

import { redirect } from '../../common/client/sagas/common';

import history from '../../history';

import OverviewPanel from './OverviewPanel';

const classNames = mergeStyleSets({
    content: {
        paddingTop: 16
    }
});

const ModuleButton = ({text, text2, disabled, modulePath}) => {

    const handleOnClick = () => {
        redirect(modulePath, {history});
    }

    return (
        <CompoundButton
            secondaryText={text2}
            disabled={disabled}
            primary
            onClick={handleOnClick}
        >
            {text}
        </CompoundButton>
    );
}

const OverviewPanelModules = ({projectId}) => {

    const katuze = useSelector(state => state.katuze);

    return (
        <OverviewPanel title="SEZNAM DOSTUPNÝCH MODULŮ" loaded={true}>
            <Stack className={classNames.content} tokens={{childrenGap: 16}}>
                <ModuleButton
                    text="KN průzkumník"
                    text2="Vyhledávání a zobrazování dat KN (parcely, LV, vlastníci)"
                    modulePath={`/isknExplorer/${projectId}`}
                    disabled={!katuze.loaded}
                />
                <ModuleButton
                    text="Analýza vlastnictví"
                    text2="Analýza vlastnických vztahů v historii"
                    modulePath={`/analyzeVla/${projectId}`}
                    disabled={!katuze.loaded}
                />
                <ModuleButton
                    text="Analýza dvou vlastníků"
                    text2="Analýza převodu parcel mezi dvěma vlastníky v historii"
                    modulePath={`/analyze2opsub/${projectId}`}
                    disabled={!katuze.loaded}
                />
                <ModuleButton
                    text="Analýza zaniklých parcel"
                    text2="Analýza parcel které zanikly a na jejich místě vznikly jiné"
                    modulePath={`/analyzeDefunctPar/${projectId}`}
                    disabled={!katuze.loaded}
                />
                <ModuleButton
                    text="Info o datových sadách ISKN z wH"
                    text2="Přehled o datech ISKN pro jednotlivé katastrální území v datových sadách vytvořených z webHONITBA"
                    modulePath={`/isknActualInfo/${projectId}`}
                    disabled={!katuze.loaded}
                />
            </Stack>
        </OverviewPanel>
    );
}

export default OverviewPanelModules;
